var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "98px",
    viewBox: "0 0 192 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 192,
    height: 98,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-93.5%",
    y: "-77.5%",
    width: "287.1%",
    height: "250.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.276   0 0 0 0 0.3624   0 0 0 0 0.6  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 14.1176471,
    cy: 14.1176471,
    r: 14.1176471
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 25.0505051,
    y: 16.8342246,
    width: 4.44444444,
    height: 13.4117647,
    rx: 2.22222222
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-675.0%",
    y: "-223.7%",
    width: "1450.0%",
    height: "547.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.3   0 0 0 0 0.425   0 0 0 0 0.6  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 25.0505051,
    y: 32.3636364,
    width: 4.44444444,
    height: 4.47058824,
    rx: 2.22222222
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-675.0%",
    y: "-671.1%",
    width: "1450.0%",
    height: "1442.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.3   0 0 0 0 0.425   0 0 0 0 0.6  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-19.0382892%",
    y1: "31.3494412%",
    x2: "100%",
    y2: "63.0262587%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C4E6",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A8CBF",
    stopOpacity: 0.589730862,
    offset: "52.023902%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82B8",
    stopOpacity: 0.7,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbnail",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B8C4E6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#ABB8DB",
    mask: "url(#mask-2)",
    points: "162 0 64 98 265.513949 98 265.513949 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    filter: "url(#filter-3)",
    transform: "translate(98.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8394C2",
    x: 7.27272727,
    y: 7.27272727,
    width: 54.5454545,
    height: 72.7272727,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8636364,56.5909091 L25.506993,80 L13.125,80 C9.89287902,80 7.27272727,77.3798483 7.27272727,74.1477273 L7.27272727,74.1477273 L7.27272727,70.8830401 L48.8636364,56.5909091 Z",
    id: "Path-2",
    fill: "#6E82B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L48,0 C52.418278,-8.11624501e-16 56,3.581722 56,8 L56,51 L35,72 L8,72 C3.581722,72 5.41083001e-16,68.418278 0,64 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z",
    id: "Rectangle",
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DDE2F0",
    points: "36 55 19 72 35.1735044 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,51 L56,51 L35,72 L35,59 C35,54.581722 38.581722,51 43,51 Z",
    id: "Rectangle",
    fill: "#B8C4E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-5",
    transform: "translate(13.176471, 12.727273)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B8C4E6",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ABB8DB",
    mask: "url(#mask-5)",
    points: "28.2352941 0 0 28.2352941 28.2352941 28.2352941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F3FA",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F3FA",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-10)",
    x: 0,
    y: 0,
    width: 192,
    height: 98,
    rx: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.3aac3d30b1340f195acc4c456e277575.svg";
export { ForwardRef as ReactComponent };